export enum DIRECTORY_CSV_GENERATION_STATUS {
  COMPLETED = "Completed",
  FAILED = "Failed",
  IN_PROGRESS = "In Progress",
  NONE = "Not Found",
}
